import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=b8bb1f3e&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"
import style0 from "./Product.vue?vue&type=style&index=0&id=b8bb1f3e&prod&lang=css"
import style1 from "../assets/product.css?vue&type=style&index=1&id=b8bb1f3e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bb1f3e",
  null
  
)

export default component.exports